<div><svg class="align-middle inline-block" v-if="svgContent" :style="svgStyle" viewBox="0 0 24 24" v-html="svgContent"></svg><slot></slot></div>